/* eslint-disable react/prop-types */
import { getMotivosRetencionDePagos } from 'api/catalogos/motivosDeRetencionDePagos';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getEstadosDeRetenciones } from 'api/nominas/retencion/estadosDeRetencionDePagos';
import {
  getHistoricosRetencionesDePagos,
} from 'api/nominas/retencion/historicoRetencionDePagos';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';

export const HistoricoRetencionDePagosPermission = {
  permissionModel: 'historicoretenciondepagoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteRetenciones = ({
  currentEmpleado,
}) => {
  const [motivosDeRetencionDePago, setMotivosDeRetencionDePago] = useState([]);
  const [periodosNominaDetalle, setPeriodosNominaDetalle] = useState([]);
  const [estatusRetenciones, setEstatusRetenciones] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPermission = getModelPermission(
    HistoricoRetencionDePagosPermission.permissionModel,
    HistoricoRetencionDePagosPermission.catalogsModels,
    HistoricoRetencionDePagosPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _motivosRetenciones,
        _periodosNominasDetalles,
        _estatusRetenciones,
        _data,
      ] = await Promise.all([
        getMotivosRetencionDePagos(),
        getPeriodosDeNominasDetalles(),
        getEstadosDeRetenciones(),
        getHistoricosRetencionesDePagos({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setMotivosDeRetencionDePago(_motivosRetenciones);
        setPeriodosNominaDetalle(formatReceived(_periodosNominasDetalles));
        setEstatusRetenciones(_estatusRetenciones);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Motivo de Retención de Pago',
      dataIndex: 'motivo_de_retencion_de_pago',
      key: 'motivo_de_retencion_de_pago',
      width: 250,
      render: (val) => motivosDeRetencionDePago.find((e) => e.id === val)?.motivo,
    },
    {
      titleText: 'Periodo de Nómina Retenido',
      dataIndex: 'periodo_de_nomina_retenido',
      key: 'periodo_de_nomina_retenido',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominaDetalle.find((e) => e.id === val);
        const _fechaInicial = _periodo?.fecha_inicial.format();
        const _fechaFinal = _periodo?.fecha_final.format();
        return `${_periodo?.numero_de_nomina} - ${_fechaInicial} al ${_fechaFinal}`;
      },
    },
    {
      titleText: 'Periodo de Nómina de Retención',
      dataIndex: 'periodo_de_nomina_retencion',
      key: 'periodo_de_nomina_retencion',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominaDetalle.find((e) => e.id === val);
        const _fechaInicial = _periodo?.fecha_inicial.format();
        const _fechaFinal = _periodo?.fecha_final.format();
        return `${_periodo?.numero_de_nomina} - ${_fechaInicial} al ${_fechaFinal}`;
      },
    },
    {
      titleText: 'Fecha de Liberación o Cancelación',
      dataIndex: 'fecha_liberacion_cancelacion',
      key: 'fecha_liberacion_cancelacion',
      width: 270,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    // {
    //   titleText: 'Observaciones',
    //   dataIndex: 'observaciones',
    //   key: 'observaciones',
    //   width: 300,
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_retencion',
      key: 'estado_retencion',
      width: 200,
      render: (val) => estatusRetenciones.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          permission={getPermission}
          allowExportPDF={false}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ExpedienteRetenciones;
